import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Button, Card, Result } from 'antd';

import './index.css';

const BillingPage = () => {
  const location = useLocation();
  const history = useHistory();

  const isSuccess = location.pathname.includes('/success');

  const handleGoHome = () => {
    history.push('/');
  };

  return (
    <div className="billing-page-container">
      <Card className="billing-card">
        {isSuccess ? (
          <Result
            status="success"
            title="Payment Successful!"
            subTitle="Your subscription has been activated. Enjoy the full features."
            extra={[
              <Button type="primary" key="home" onClick={handleGoHome} className="billing-btn">
                Go to Dashboard
              </Button>
            ]}
          />
        ) : (
          <Result
            status="error"
            title="Payment Cancelled"
            subTitle="Your subscription was not completed. You can try again anytime."
            extra={[
              <Button type="primary" key="retry" onClick={handleGoHome} className="billing-btn">
                Return Home
              </Button>
            ]}
          />
        )}
      </Card>
    </div>
  );
};

export default BillingPage;
